// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-0c8687e0] .p-panel .p-panel-header {\n  padding: 0.5rem;\n  border: none;\n  background: #84abd6 !important;\n  -webkit-box-orient: vertical !important;\n  -webkit-box-direction: normal !important;\n      -ms-flex-direction: column !important;\n          flex-direction: column !important;\n}\n[data-v-0c8687e0] .p-panel-content {\n  padding: 0.2rem;\n}\n[data-v-0c8687e0] .p-message {\n  margin: 1px;\n}\n[data-v-0c8687e0] .p-message-wrapper {\n  padding: 0.4rem 1rem;\n}", ""]);
// Exports
module.exports = exports;
